var exports = {
  "n": "xfd349460--8ec6d8--link",
  "K": "xfd349460--8ec6d8--icon",
};

module.exports = exports;
